// src/hooks/useInitCMSData.js
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as types from '../redux/actions/CMSData';
import * as langtype from '../redux/actions/LanguageList';

const useInitCMSData = () => {
    const dispatch = useDispatch();

    const CMSData = useSelector(state => state.cmsdatadetail.cmsdatadetail);
    const LanguageListing = useSelector(state => state.language.languageList) || [];

    useEffect(() => {
        if (!CMSData || Object.keys(CMSData).length === 0) {
            dispatch({ type: types.FETCH_CMSDATA_REQUEST });
        }

        if (!LanguageListing || LanguageListing.length === 0) {
            dispatch({ type: langtype.FETCH_LANGUAGE_REQUEST });
        }
    }, [dispatch, CMSData, LanguageListing]);

    return {
        CMSData,
        LanguageListing
    };
};

export default useInitCMSData;
